
const errorResponseHandler = (payload, dataType) => {
    let errorObj = {}, 
        errorKey = 'error' + dataType,
        errorMsgKey = 'errorMessage' + dataType,
        retryKey = 'retry' + dataType;
        
        payload = payload || {};
    
    errorObj[errorKey] = true;
    
    if(payload.status >= 400 && payload.status < 500){
        const keys = Object.keys(payload.data);
        let msgArray = [];
        
        if(keys.length > 0){
            
            for(let i in keys){
                let msgKey = keys[i],
                    errorField = msgKey.charAt(0).toUpperCase() + msgKey.slice(1).toLowerCase();
                
                let errorMsg = errorField.replace('_', ' ') + ': ' + payload.data[msgKey];
                
                // Use explicit message key failed to show only payload message
                msgArray.push(msgKey === 'failed' ? payload.data[msgKey] : errorMsg);
            }
        }

        errorObj[errorMsgKey] = msgArray;
    }
    else if(payload.status >= 500){
        errorObj[errorMsgKey] = ['A server error occurred. Request could not be completed'];
    }
    else{
        errorObj[errorMsgKey] = ['Could not connect to server. Retry?'];
        errorObj[retryKey] = true;
    }

    return errorObj;
}

export { errorResponseHandler };


// WEBPACK FOOTER //
// ./src/utils/error-utils.js